<template>

  <app-layout>
    <a-spin :spinning="loading">
      <div class="h-full flex">
        <div class="flex flex-col w-0 flex-1">
          <main class="flex-1 relative focus:outline-none px-8">
            <bread-nav :pages="pages"></bread-nav>
            <div class="pt-8 pb-16">
              <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="container mx-auto max-w-7xl text-center">


                  <div class=" flex flex-wrap w-full px-4 space-y-8">
                    <div class="grid grid-cols-2 w-full gap-4">
                      <div class="text-left col-span-2 md:col-span-1 shadow rounded-lg bg-white">
                        <div class="px-4 py-5 overflow-hidden sm:p-6">
                          <dt class="text-sm font-medium text-gray-500 truncate">
                            Current Plan
                          </dt>
                          <dd class="mt-1 text-3xl font-semibold text-gray-900">
                            {{ plan.name ?? 'Free'}}
                            <div v-if="!(plan.unit_price===0)" class="text-sm">
                              <div v-if="plan.is_per_seat">
                                ${{ plan.unit_price }} {{ plan.unit }} / user / month
                              </div>
                              <div v-else>
                                ${{ plan.unit_price }} {{ plan.unit }} / month
                              </div>
                            </div>
                          </dd>
                        </div>
                      </div>

                      <div class="text-left col-span-2 bg-white md:col-span-1 shadow rounded-lg">
                        <div class="px-4 py-5 overflow-hidden sm:p-6">
                          <dt class="text-sm font-medium text-gray-500 truncate">
                            Current Total Unique Members
                          </dt>
                          <dd class="mt-1 text-3xl font-semibold text-gray-900">
                            {{ this.uniqueMemberCount }}
                          </dd>
                        </div>
                      </div>
                    </div>

                    <div class="grid grid-cols-3 gap-4">
                      <Plan icon-url="/images/free.png" :features="freePlanFeatures" plan-name="Free"/>
                      <PremiumPlan :planSettings="planSettings" :plan="plan" :uniqueMemberCount="uniqueMemberCount"
                                   :userId="userId" @setLoading="setLoading" @fetchPlan="fetchPlan"/>
                      <Plan
                          icon-url="/images/free.png"
                          plan-name="Enterprise"
                          plan-desc="For those companies with expensive usage. Please contact us. Our plans are designed for
                small to medium size."
                          cta-label="Contact Us"
                      />
                    </div>
                    <div class="flex-row">
                      <div class="flex">
                        <small class="text-sm">* Seat Usage/Premium Account: A subscribed account is able to create premium team and all
                          members belong to
                          that team
                          can access all paid features. If the same email assigned to
                          different team, the system marks it as one unique seat usage.</small>
                      </div>
                      <div class="flex">
                        <small class="text-sm">* Async Report: The max number of participants for each report template is restricted to
                          10 for free customers.</small>
                      </div>
                      <div class="flex">
                        <small class="text-sm">* Async Report: Each Slack workspace can only have 1 free report template.</small>
                      </div>
                      <div class="flex">
                        <small class="text-sm">* Async Report: The report template is a schedule setting that allows you configure
                          your
                          report
                          recurrence.</small>
                      </div>
                      <div class="flex">
                        <small class="text-sm">* Async Report: A paid user can generate up to 20 report templates per account. Contact us if
                          you require
                          more.</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </a-spin>
  </app-layout>

</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import BreadNav from "@/Components/BreadNav/BreadNav";
import {ref} from 'vue';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal'
import JetDangerButton from '@/Jetstream/DangerButton'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import {message} from "ant-design-vue";


import {MailIcon, UsersIcon,} from "@heroicons/vue/outline";
import NoData from "@/Components/NoData/NoData";
import UpdateBillingForm from "@/Pages/Profile/UpdateBillingForm";
import Plan from "./Plan";
import PremiumPlan from "./PremiumPlan";

const pages = [
  {name: 'Billing', href: '#', current: false},
  {name: 'Subscriptions', href: '#', current: true},
]

export default {
  props: [
    'planSettings',
    'plan',
    'uniqueMemberCount',
    'userId'
  ],
  data() {
    return {
      freePlanFeatures: [
        {
          text: "Public Retro Boards - ",
          subText: "3"
        },
        {
          text: "Public Poker Sessions - ",
          subText: "100"
        },
        {
          text: "Slack Async Report - ",
          subText: "1 Report Template*"
        }
      ]
    };
  },
  beforeMount() {

  },
  created() {
  },
  setup(props, context) {
    const selected = ref(null);
    const submitting = ref(false);
    const confirmModal = ref(false);
    const loading = ref(false);
    const plan = ref(props.plan);
    const removeClicked = (user) => {
      selected.value = user;
      confirmModal.value = true;
    }

    const confirmDelete = () => {
      submitting.value = true;
      confirmModal.value = false;

      axios
          .post(route("billing.usage.delete"), {
            user_id: selected.value.id
          })
          .then((response) => {
            submitting.value = false;
            message.success('Successfully removed', 5);
            window.location.reload();
          })
          .catch((error) => {
            submitting.value = false;
            console.log(error);
            message.error('Our system cannot delete it, please contact us.', 5);
          });
    }


    function setLoading(l) {
      loading.value = l;
    }

    function fetchPlan() {
      // plan.value = {unit_price: 4.8, unit: "USD", name: "Retrospective & Planning Poker", is_per_seat: true};
      loading.value = true;
      axios.get(route("billing.currentPlan")).then((response) => {
            plan.value = response.data.plan;
            loading.value = false;
          }
      );
    }



    return {
      confirmDelete,
      submitting,
      removeClicked,
      confirmModal,
      pages,
      loading,
      setLoading,
      fetchPlan,
      plan
    }
  },

  methods: {},
  components: {
    PremiumPlan,
    Plan,
    UpdateBillingForm,
    NoData,
    JetConfirmationModal,
    JetDangerButton,
    JetSecondaryButton,
    MailIcon,
    UsersIcon,
    BreadNav,
    AppLayout,
  },
};
</script>
